<template>
	<div>
	  <input type="file" id='fileInput'>
	  <button id="uploadBtn" @click="doUpload">Upload</button>
	  <button id="stopBtn" onclick="stop()">Stop</button>
	  <button id="resumeBtn" onclick="resume()">resume</button>
	  <h2 id='status'></h2>
	</div>
</template>

<script>
	const OSS = require('ali-oss');
export default {
	data(){
		return {
		}
	},
	computed:{
	  
	},
	methods:{
		doUpload() {
		  	this.http.get('/upload/getUpoadVideoToken').then(response=>{
				let data=response.data;
				console.log(data);
				if(data.StatusCode!=200){
					this.$Message.error(data.message);
				} else {
					const config = data;
					console.log(config);

					const ossClient = new OSS({
						accessKeyId: config.AccessKeyId,
						accessKeySecret: config.AccessKeySecret,
						stsToken: config.SecurityToken,
						bucket:config.bucket,
						region:config.RegionId,
						secure:true,
						endpoint:'oss-cn-zhangjiakou.aliyuncs.com'
					});
					
					const fileName = this.file.name;  
					const progress = (p, _checkpoint) => {
						// Object的上传进度。
						console.log(p); 
						// 分片上传的断点信息。
						console.log(_checkpoint); 
					};
					 
					ossClient.multipartUpload('freefishpc/app_download/'+fileName, this.file,{progress}).then(
						result => {     
							console.log(`Common upload ${fileName} succeeded, result === `, result)   
						}).catch(
							err => {     
								console.log(`Common upload ${fileName} failed === `, err);   
						}); 	
				}
		  	}).catch(()=>{
		  	  this.$Message.error('网络错误');
		  	});
		  },
	}	
}
</script>

<style>
</style>